<template>
  <div class="knowledgeBase">
    <div class="index-header">
      <span class="title">
        <svg-icon icon-class="knowLedgeBase" class="iconstyle"></svg-icon>行业知识库
      </span>
      <span class="other more" @click="jumpMore">
        更多
        <i class="el-icon-d-arrow-right"></i>
      </span>
    </div>
    <div class="container">
      <div class="news" v-if="!showNoMessageImg">
        <li class="ft12" v-for="(item,index) in dataFeed" :key="index" @click="toDetail(item)">
          <span class="title ub-f1">{{item.MianTitle.substring(0,12)}}...</span>
          <span class="time">{{item.PubTime|formatDate('yyyy-MM-dd')}}</span>
        </li>
      </div>
      <div class="Img" v-if="showNoMessageImg">
        <img src="@/components/indexnew/img/noMessage.png" />
      </div>
    </div>
  </div>
</template>

<script>
import { devEnvironment, proEnvironment } from "@/assets/js/division";
import { ArticleControllerSvr } from "@/service/ArticleControllerSvr.js";
import { ArticleQueryPara } from "@/models/queryparams/ArticleQueryPara.js";
import { mapState } from "vuex";
import {aesEncrypt} from '@/utils/aes.js';
export default {
  components: {},
  props: {},
  data() {
    return {
      baseURL: "",
      ArticleQueryPara: new ArticleQueryPara(),
      dataFeed: [],
      showNoMessageImg: true,
      aesEncrypt: aesEncrypt
    };
  },
  computed: { ...mapState(["token"]) },
  created() {
    this.ArticleControllerSvr = new ArticleControllerSvr();
  },
  mounted() {
    this.getdate();
  },
  methods: {
    // 加密后的文件路径
    encryptFileUrl(attachMentId) {
      const enAttachMentId = this.aesEncrypt(attachMentId);
      const strText = this.aesEncrypt(`${this.token},${attachMentId}`);
      const times = this.aesEncrypt(new Date().getTime().toString());
      const imgEnUrl = `${this.baseURL}importantDocByNewController.assx/checkImportantDoc?token=${this.token}&attachMentId=${enAttachMentId}&strText=${strText}&times=${times}`;
      return imgEnUrl;
    },
    jumpMore() {
      this.$router.push({ path: "knowledgeBaseMore", query: { t: Date.now() } });
    },
    getdate() {
      const myworkLoading = this.$loading({
        target: document.querySelector(".news")
      });
      this.ArticleControllerSvr.GetKnowledgeBase(
        this.token,
        "",
        "003001,007001",
        0,
        5,
        true
      )
        .then(res => {
          this.dataFeed = res._Items;
          this.showNoMessageImg = false;
          myworkLoading.close();
        })
        .catch(() => {
          myworkLoading.close();
        });
    },
    toDetail(item) {
      if (item.CategoryCode === "008001") {
        this.ImportExpertTemplate(item.AttachmentIds);
      } else {
        this.$router.push({
          path: "knowledgeBaseDetail",
          query: {
            KeyId: item.KeyId,
            t: Date.now()
          }
        });
      }
    },
    //下载
    ImportExpertTemplate(AttachmentIds) {
      if (process.env.NODE_ENV === "development") {
        this.baseURL = devEnvironment;
      } else if (process.env.NODE_ENV === "production") {
        this.baseURL = 'szwyweb/';
      }
      const imgSrc = this.encryptFileUrl(AttachmentIds);
      const userAgent = navigator.userAgent; //取得浏览器的userAgent字符串
      if (userAgent.indexOf("Firefox") > -1) {
        var a = document.createElement("a");
        a.setAttribute("download", ""); // download属性
        a.setAttribute("id", "abc");
        a.href = imgSrc;
        document.getElementsByTagName("body")[0].appendChild(a); // 修复firefox中无法触发click
        a.click();
        var idObject = document.getElementById("abc");
        if (idObject !== null) idObject.parentNode.removeChild(idObject);
      } else {
        const a = document.createElement("a"); // 创建a标签
        a.setAttribute("download", ""); // download属性
        a.setAttribute("href", imgSrc); // href链接
        a.click(); // 自执行点击事件
      }
    }
  }
};
</script>
<style lang="scss" scoped>
@import "./css/common.scss";
.knowledgeBase {
  background: #fff;
  .iconstyle {
    font-size: 18px;
    margin: 0 6px;
    color: #0f77f2;
  }
  .container {
    height: 140px;
    padding: 10px 0;
    overflow: hidden;
    .Img {
      padding: 5px 12px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .news {
      li {
        padding: 5px 12px;
        display: flex;
        justify-content: space-between;
        border-bottom: 1px solid #eee;
        height: 40px;
        font-size: 14px;
        box-sizing: border-box;
        line-height: 30px;
        cursor: pointer;
        .title {
          position: relative;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          .hot {
            display: inline-block;
            position: relative;
            top: -4px;
            height: 7px;
            width: 18px;
            background: #ff4546;
            img {
              position: absolute;
              top: 0;
            }
          }
        }
        &:nth-child(2n) {
          background: #f7f8fa;
        }
        &:hover {
          background: #e3f0ff;
        }
      }
    }
  }
}
</style>
